<template>
<div>
  phone
</div>
</template>

<script>
export default {
  name: "phonePageQr"
}
</script>

<style scoped>

</style>
